import "./tabsbar.css";
import { BiUser } from "react-icons/bi";
import { BsHeart } from "react-icons/bs";
import { HiOutlineShoppingBag } from "react-icons/hi";
import { Link } from "react-router-dom";
import cookies from "js-cookie";

import * as main_category from "../network/api/maincategory.js";
import { useEffect, useState } from "react";

function Tabsbar() {
  const token = cookies.get("user");

  const [id, setid] = useState("");

  useEffect(() => {
    main_category
      .getcategories()
      .then((result) => {
        const firstId = result?.data?.response?.[0]?._id;
        if (firstId) setid(firstId);
      })
      .catch(() => {
        // no-op; leave id empty
      });
  }, []);
  return (
    <div className="tabsbar d-lg-none">
      {token ? (
        <Link to="/profile" className="d-flex flex-column align-items-center">
          <span>
            <BiUser />
          </span>
          <p>الحساب</p>
        </Link>
      ) : (
        <Link
          to="#Login"
          data-bs-toggle="modal"
          className="d-flex flex-column align-items-center"
        >
          <span>
            <BiUser />
          </span>
          <p>الحساب</p>
        </Link>
      )}
      {token ? (
        <Link to="/wishlist" className="d-flex flex-column align-items-center">
          <span>
            <BsHeart />
          </span>
          <p>قائمة الامنيات</p>
        </Link>
      ) : (
        <Link
          to="#Login"
          data-bs-toggle="modal"
          className="d-flex flex-column align-items-center"
        >
          <span>
            <BsHeart />
          </span>
          <p>قائمة الامنيات</p>
        </Link>
      )}
      {token ? (
        <Link to="/cart" className="d-flex flex-column align-items-center">
          <span>
            <HiOutlineShoppingBag />
          </span>
          <p>السلة </p>
        </Link>
      ) : (
        <Link
          to="#Login"
          data-bs-toggle="modal"
          className="d-flex flex-column align-items-center"
        >
          <span>
            <HiOutlineShoppingBag />
          </span>
          <p>السلة </p>
        </Link>
      )}
      <Link to={`/c/${id}`} className="d-flex flex-column align-items-center">
        <span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
          >
            <path
              d="M12.5 18V15"
              stroke="#292D32"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M10.5693 2.81985L3.63929 8.36985C2.85929 8.98985 2.35929 10.2998 2.52929 11.2798L3.85929 19.2398C4.09929 20.6598 5.45929 21.8098 6.89929 21.8098H18.0993C19.5293 21.8098 20.8993 20.6498 21.1393 19.2398L22.4693 11.2798C22.6293 10.2998 22.1293 8.98985 21.3593 8.36985L14.4293 2.82985C13.3593 1.96985 11.6293 1.96985 10.5693 2.81985Z"
              stroke="#292D32"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </span>
        <p>الرئيسية </p>
      </Link>
    </div>
  );
}
export default Tabsbar;
